{
  "version": 1,
  "asset_id": "cc03a4c4-53d6-40f0-a470-5878c67e9ef8",
  "project_id": "ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe",
  "url": "/__l5e/assets-v1/cc03a4c4-53d6-40f0-a470-5878c67e9ef8/posterityhealth-240.webp",
  "r2_key": "a/v1/ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe/cc03a4c4-53d6-40f0-a470-5878c67e9ef8/posterityhealth-240.webp",
  "original_filename": "posterityhealth-240.webp",
  "size": 5298,
  "content_type": "image/webp",
  "created_at": "2026-09-18T14:39:04Z"
}
